import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useRedirectPostLogin } from 'Authentication/useRedirect';
import { getLoginUrl } from 'apis';

interface ILoginButtons {
  render: (renderProps: {
    singpassButtonOnClick: (e: React.MouseEvent) => void;
    corppassButtonOnClick: (e: React.MouseEvent) => void;
  }) => React.ReactNode;
  redirectPath?: string;
}

export const LoginButtons: React.FC<ILoginButtons> = ({ render, redirectPath }) => {
  const { setPostLoginRedirectPath } = useRedirectPostLogin();
  const { pathname, hash } = useLocation();
  const path = redirectPath ?? pathname;

  const singpassButtonOnClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      setPostLoginRedirectPath(path + hash);
      getLoginUrl('singpass').then(({ data }) => window.location.assign(data.url));
    },
    [setPostLoginRedirectPath, path, getLoginUrl],
  );

  const corppassButtonOnClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      setPostLoginRedirectPath(path);
      getLoginUrl('corppass').then(({ data }) => window.location.assign(data.url));
    },
    [setPostLoginRedirectPath, path, getLoginUrl],
  );

  return <>{render({ singpassButtonOnClick, corppassButtonOnClick })}</>;
};
